module.exports = __webpack_public_path__ + "static/media/presentation.005e8dcd.png";